<template>
  <div>
    <div class="search-wrapper">

      <div class="search">
        <span>单位名称：</span>
        <Input
          style="width:180px;"
          placeholder="模糊查询"
          v-model="searchValue.searchCompanyName"
        ></Input>
      </div>
      <div class="search">
        <span>项目简编：</span>
        <Input
          style="width:100px;"
          v-model="searchValue.searchNumAbbr"
        ></Input>
      </div>
      <div class="search">
        <span>项目编号：</span>
        <Input
          style="width:150px;"
          v-model="searchValue.searchNum"
        ></Input>
      </div>
      <div class="search">
        <span>支付方式：</span>
        <Input
          style="width:100px;"
          v-model="searchValue.searchPayType"
        ></Input>
      </div>
      <div class="search">
        <span>发票类型：</span>
        <Input
          style="width:80px;"
          v-model="searchValue.searchArea"
        ></Input>
      </div>
      <div class="search">
        <span>服务费状态：</span>
        <Select style="width:100px;" v-model="searchValue.searchStatus">
          <Option value="0">未确认</Option>
          <Option value="1">已录入</Option>
        </Select>
      </div>
      <Button
        type="primary"
        icon="ios-search"
        style="margin: 0 10px;"
        @click="searchEnroll"
      >搜索</Button>
      <!-- <Button
        type="success"
        @click="articleChooseVisible=true"
        style="margin-right:5px;"
      >服务费录入</Button>
      <Button
        type="success"
        @click="showServiceReport"
      >服务费收入一览</Button> -->
    </div>
    <Spin
      :fix="true"
      v-if="pageSpin"
    ></Spin>
    <Table
      :columns="enrollColumns"
      :data="enrollData"
      style="min-width:1250px;"
    ></Table>
    <Page
      ref="page"
      @on-change="pageChange"
      :total="enrollTotalCount"
      show-elevator
      show-total
      style="margin:5px;"
    ></Page>
    <!-- 报名录入 -->
    <Modal
      width="900px"
      v-model="enrollFormVisible"
      :mask-closable="false"
      title="服务费"
    >
      <div id="input-form">
        <Form
          ref="supplierInputForm"
          :model="supplierInputForm"
          :rules="supplierFormValid"
          :label-width="80"
        >
          <table
            cellspacing="0"
            cellpadding="0"
            border-collapse="collapse"
            style="width:100%;"
          >
            <tr>
              <td class="item-half">
                <FormItem label="项目名称：">
                  <Input
                    v-model="articleData['title']"
                    readonly
                  ></Input>
                </FormItem>
              </td>
              <td class="item-half">
                <FormItem label="项目编号：">
                  <Input
                    v-model="articleData['projectNo']"
                    readonly
                  ></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="公司名称："
                  :label-width="85"
                  prop="companyName"
                  style="width: 350px;"
                >
                  <Input
                    :readonly="importMode"
                    v-model="supplierInputForm.companyName"
                  ></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  label="统一社会信用代码："
                  :label-width="135"
                  prop="companyNo"
                  style="width: 350px;"
                >
                  <Input
                    :readonly="importMode"
                    v-model="supplierInputForm.companyNo"
                  ></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="公司地址："
                  :label-width="85"
                  prop="companyAddress"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.companyAddress"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  class="valid-email"
                  label="公司电话："
                  prop="companyTel"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.companyTel"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="项目联系人："
                  :label-width="95"
                  prop="projectContact"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.projectContact"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  class="valid-email"
                  label="联系人电话："
                  :label-width="95"
                  prop="projectPhone"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.projectPhone"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="开户行："
                  prop="openBank"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.openBank"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  label="开户账号："
                  :label-width="85"
                  prop="openAccount"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.openAccount"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="服务费："
                  prop="serviceAmount"
                  style="width: 200px;"
                >
                  <Input
                    v-model="supplierInputForm.serviceAmount"
                    style="width:80px;"
                  ></Input>元
                </FormItem>
              </td>
              <td>
                <FormItem
                  style="width: 200px;"
                  :label-width="30"
                >
                  <Checkbox v-model="supplierInputForm.interService">居间服务费</Checkbox>
                </FormItem>
              </td>
            </tr>
          </table>
        </Form>
      </div>
      <span style="color: red">* 如需短信通知请填写联系人电话，否则无法发送短信通知</span>
      <div slot="footer">
        <Button
          type="error"
          @click="enrollFormVisible=false"
        >关闭</Button>
        <Button
          type="primary"
          @click="inputEnroll"
        >服务费录入</Button>
      </div>
    </Modal>
    <!-- 退款时间 -->
    <Modal v-model="refundInfoVisible" title="退款">
      <span>退款时间：</span>
      <DatePicker type="datetime" v-model="refundTime"></DatePicker>
      <div slot="footer">
        <Button @click="refundInfoVisible=false">取消</Button>
        <Button @click="directRefund" type="primary">确定</Button>
      </div>
    </Modal>
    <!-- 发票信息 -->
    <Modal v-model="invoiceListVisible" title="发票信息" width="850">
      <Table :columns="invoiceColumns" :data="invoiceList"></Table>
      <!-- 红冲发票 -->
      <Modal v-model="redInvoiceVisible" :transfer="false">
        <div slot="header">
          <span v-if="invoiceInputMode==='录入发票'">录入红冲发票</span>
          <span v-else>电子红冲发票</span>
        </div>
        <div>
          <div
            class="redinvoice-item"
            v-if="invoiceInputMode==='录入发票'"
          >
            <label>红冲发票号码：</label>
            <Input
              v-model="redInvoiceHm"
              style="width:300px;"
              placeholder="红冲发票号码"
            ></Input>
          </div>
          <div
            class="redinvoice-item"
            v-if="invoiceInputMode==='录入发票'"
          >
            <label>红冲开票时间：</label>
            <DatePicker
              type="date"
              style="width: 150px"
              v-model="redInvoiceTime"
            ></DatePicker>
          </div>
          <div class="redinvoice-item">
            <label>开票人：</label>
            <Input
              v-model="redInvoiceMaker"
              style="width:300px;"
              placeholder="开票人姓名"
            ></Input>
          </div>
          <div class="redinvoice-item">
            <label>收款人：</label>
            <Input
              v-model="redInvoicePayee"
              style="width:300px;"
              placeholder="收款人姓名"
            ></Input>
          </div>
          <div class="redinvoice-item">
            <label>复核人：</label>
            <Input
              v-model="redInvoiceCheck"
              style="width:300px;"
              placeholder="复核人姓名"
            ></Input>
          </div>
        </div>
        <div slot="footer">
          <Button @click="redInvoiceVisible=false">取消</Button>
          <Button
            @click="makeRedInvoice"
            type="primary"
          >确定</Button>
        </div>
      </Modal>
      <!-- 修改发票信息 -->
      <Modal
        v-model="invoiceEditVisible"
        title="发票修改" :transfer="false">
        <Form
          inline
          :label-width="80"
        >
          <FormItem label="发票号码">
            <Input
              v-model="invoiceEdit.invoiceHm"
              style="width:100px;"
            ></Input>
          </FormItem>
          <FormItem label="发票时间">
            <DatePicker
              v-model="invoiceEdit.invoiceDate"
              style="width:150px;"
            ></DatePicker>
          </FormItem>
          <FormItem label="发票金额">
            <Input
              v-model="invoiceEdit.invoiceAmount"
              style="width:150px;"
            ></Input>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="invoiceEditVisible=false">取消</Button>
          <Button
            @click="editInvoiceData"
            type="primary"
          >确定</Button>
        </div>
      </Modal>
      <div slot="footer"></div>
    </Modal>
    <!-- 服务费信息 -->
    <Modal
      title="服务费信息"
      v-model="serviceInfoVisible"
    >
      <Form
        :label-width="85"
        inline
        class="service-form"
      >
        <FormItem label="公司名称：">
          <span>{{viewServiceInfo.companyName | emptyFilter}}</span>
        </FormItem>
        <FormItem label="信用代码：">
          <span>{{viewServiceInfo.companyNo | emptyFilter}}</span>
        </FormItem>
        <FormItem label="公司地址：">
          <span>{{viewServiceInfo.companyAddress | emptyFilter}}</span>
        </FormItem>
        <FormItem label="公司电话：">
          <span>{{viewServiceInfo.companyTel | emptyFilter}}</span>
        </FormItem>
        <FormItem label="项目联系人：">
          <span>{{viewServiceInfo.projectContact | emptyFilter}}</span>
        </FormItem>
        <FormItem label="联系人电话：">
          <span>{{viewServiceInfo.projectPhone | emptyFilter}}</span>
        </FormItem>
        <FormItem label="开户行：">
          <span>{{viewServiceInfo.openBank | emptyFilter}}</span>
        </FormItem>
        <FormItem label="开户账号：">
          <span>{{viewServiceInfo.openAccount | emptyFilter}}</span>
        </FormItem>
        <FormItem label="服务费：">
          <span>{{viewServiceInfo.amount | emptyFilter}}</span>
        </FormItem>
        <FormItem label="居间服务费：">
          <span>{{viewServiceInfo.intermediary | interServiceFilter}}</span>
        </FormItem>
      </Form>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="confirmServiceVisible"
      title="服务费确认"
    >
      <Form>
        <FormItem
          label="是否计算提成："
          required
          :label-width="120"
        >
          <RadioGroup v-model="isPushMoney">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="服务费确认人："
          required
          :label-width="120"
        >
          <Input
            v-model="serviceConfirm"
            style="width:100px;"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="confirmServiceVisible=false">取消</Button>
        <Button
          @click="confirmService"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 信息补录 -->
    <Modal
      v-model="extraInfoVisible"
      title="信息补录"
      class="info-modal"
    >
      <Card>
        <span slot="title">合同信息</span>
        <span slot="extra">
          <Button
            type="primary"
            size="small"
            @click="supplyOtherInfo"
          >确认</Button>
        </span>
        <Form
          inline
          :label-width="80"
        >
          <FormItem label="合同编号">
            <Input
              style="width: 120px"
              v-model="additionInfo.pactNo"
            ></Input>
          </FormItem>
          <FormItem label="合同时间">
            <DatePicker
              type="date"
              style="width: 150px"
              v-model="additionInfo.pactTime"
            ></DatePicker>
          </FormItem>
          <FormItem
            label="保证金退还时间"
            :label-width="100"
          >
            <DatePicker
              type="date"
              style="width: 150px"
              v-model="additionInfo.backTime"
            ></DatePicker>
          </FormItem>
        </Form>
      </Card>
      <Card>
        <span slot="title">服务费信息</span>
        <span slot="extra">
          <Button
            type="primary"
            size="small"
            @click="supplyOtherInfo"
          >确认</Button>
        </span>
        <Form
          inline
          :label-width="80"
        >
          <FormItem label="服务费金额">
            <Input
              style="width: 120px"
              v-model="additionInfo.serviceAmount"
            ></Input>
          </FormItem>
          <FormItem label="支付方式">
            <Select
              v-model="additionInfo.paymentType"
              style="width: 150px"
            >
              <Option
                v-for="item in paymentTypes"
                :value="item.value"
                :key="item.value"
              >{{item.value}}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="服务费收取时间"
            :label-width="100"
          >
            <DatePicker
              type="date"
              style="width: 150px"
              v-model="additionInfo.getFeeTime"
            ></DatePicker>
          </FormItem>
          <FormItem
            label="备注"
            :label-width="50"
          >
            <Input
              v-model="additionInfo.comment"
              style="width:380px;"
            ></Input>
          </FormItem>
        </Form>
      </Card>
      <div slot="footer"></div>
    </Modal>
    <!-- 联系人手机号 -->
    <Modal
      v-model="contactVisible"
      title="联系人电话">
      <span>联系人电话：</span>
      <Input v-model="projectPhone" style="width: 300px"></Input>
      <div slot="footer">
        <Button type="primary" @click="contactUpdate">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import ProjectChoose from '@/components/projectChoose'
import axios from 'axios'
import Invoice from '@/components/invoice'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'
import util from '@/lib/util'
import sendMessage from "@/lib/message"

// 订单状态 1：未支付 2：已支付未开票 3：已支付已开票 4：已退款或已红冲

export default {
  name: 'serviceCharge',
  data() {
    const validateMail = async (rule, value, callback) => {
      if (this.supplierInputForm.gainMode === '3') {
        if (value === '') {
          callback(new Error('不能为空'))
        } else {
          const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('邮箱格式不正确'))
          }
        }
      } else {
        callback()
      }
    }
    const validNum = (rule, value, callback) => {
      if (isNaN(value) || value === "" || value === null) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    }
    const refundTime = formatDate()
    return {
      enrollData: [],
      payTimeValue: '',
      realPayAccountName: '',
      realPayAccount: '',
      pactNo: '',
      pactTime: '',
      confirmServiceVisible: false,
      searchType: false,
      extraInfoVisible: false,
      selectProjectData: {},
      enrollColumns: [
        {
          title: '单位名称',
          render: (h, params) => {
            return h('div', params.row.companyName)
          }
        },
        {
          title: '项目编号',
          width: 175,
          key: 'projectFull'
        },
        {
          title: '添加时间',
          key: 'creationTime',
          width: 100,
          render: (h, params) => {
            let time = ''
            if (params.row.creationTime) {
              time = params.row.creationTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '服务费',
          key: 'amount',
          width: 80
        },
        {
          title: '收取时间',
          width: 100,
          render: (h, params) => {
            let time = '无'
            if (params.row.ordersDto && params.row.ordersDto.payTime) {
              time = params.row.ordersDto.payTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '支付方式',
          width: 85,
          render: (h, params) => {
            let bank = '无'
            if (params.row.ordersDto) {
              bank = params.row.ordersDto.payChannel
            }
            return h('div', bank)
          }
        },
        {
          title: '发票',
          width: 60,
          render: (h, params) => {
            let open = '未开'
            if (params.row.ordersDto && params.row.ordersDto.orderStatus === '3') {
              open = '已开'
            }
            if (params.row.ordersDto && params.row.ordersDto.orderStatus === '5') {
              open = '/'
            }
            return h('div', open)
          }
        },
        {
          title: '发票类型',
          width: 120,
          key: 'district'
        },
        {
          title: '状态',
          width: 120,
          render: (h, params) => {
            return h('div', params.row.status === '1' ? '已录入' : '未确认')
          }
        },
        {
          title: '操作',
          width: 140,
          render: (h, params) => {
            // 根据状态修改按钮
            let renderResult = [false, true]
            switch (params.row.status) {
              case '0':
                renderResult = [false, true]
                break
              case '1':
                renderResult = [true, false]
                break
              case '2':
                renderResult = [false, true]
                break
              default:
                renderResult = [true, true]
            }
            let renderArray = [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  margin: '5px 5px 5px 0'
                },
                on: {
                  click: () => {
                    this.viewServiceInfo = params.row
                    this.serviceInfoVisible = true
                  }
                }
              }, '已录入信息'),
            ]
            return h('div', renderArray);
          }
        }
      ],
      enrollTotalCount: 0,
      searchValue: {
        searchNum: '',
        searchStatus: '',
        searchArea: '',
        searchCompanyName: '',
        searchNumAbbr: '',
        searchPayType: '',
        searchPayTime: ''
      },
      refundInfoVisible: false,
      refundTime: refundTime,
      statusList: [
        {
          value: '0',
          label: '待审核'
        },
        {
          value: '2',
          label: '审核不通过'
        },
        {
          value: '1',
          label: '审核成功'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      supplierInputForm: {
        groupArr: [],
        companyName: '',
        companyNo: '',
        companyAddress: '',
        companyTel: '',
        companyMail: '',
        legalPerson: '',
        LegalPersonTel: '',
        projectContact: '',
        projectPhone: '',
        projectMail: '',
        projectFax: '',
        transactor: '',
        transactorPhone: '',
        openBank: '',
        openAccount: '',
        gainMode: '',
        gainEmail: '',
        serviceAmount: '',
        groupId: ''
      },
      supplierFormValid: {
        groupArr: [
          { required: true, type: 'array', min: 1, message: '不能为空', trigger: 'change' }
        ],
        companyName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        companyTel: [
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '电话格式不正确', trigger: 'blur' }
        ],
        projectPhone: [
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '电话格式不正确', trigger: 'blur' }
        ],
        serviceAmount: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { validator: validNum, trigger: "blur" }
        ]
      },
      enrollFormVisible: false,
      companyChooseVisible: false,
      importMode: false,
      importProjectStatus: 'projects',
      articleChooseVisible: false,
      articleData: {},
      enrollPriceShow: false,
      enrollRepData: {},
      invoiceInputMode: '电子发票',
      paymentTypes: [
        { value: '现金' },
        { value: '建设银行' },
        { value: '光大银行' },
        { value: '农业银行' },
        { value: '工商银行' },
        { value: '中国银行' },
        { value: '广发银行' },
        { value: 'POS' },
        { value: '支付宝' },
        { value: '微信' },
        { value: '慧收款' },
        { value: '中招联' },
      ],
      paymentType: '',
      examineConfirmVisible: false,
      currentPage: 1,
      makeInvoiceVisible: false,
      invoiceData: {},
      orderList: [],
      ordersVisible: false,
      ordersColumns: [
        {
          title: '订单号',
          key: 'orderNo'
        },
        {
          title: '金额',
          key: 'orderAmountTotal',
          width: 80
        },
        {
          title: '支付时间',
          width: 150,
          render: (h, params) => {
            let time = '未知时间'
            if (!!params.row.payTime) {
              time = params.row.payTime.replace('T', ' ')
            }
            return h('div', time)
          }
        },
        {
          title: '支付方式',
          width: 100,
          render: (h, params) => {
            let payChannel = '无'
            if (!!params.row.payChannel) {
              payChannel = params.row.payChannel
            }
            return h('div', payChannel)
          }
        },
        {
          title: '状态',
          width: 100,
          render: (h, params) => {
            let status = '未知状态'
            switch (params.row.orderStatus) {
              case '0':
                status = '退款订单'
                break
              case '1':
                status = '未支付'
                break
              case '2':
                status = '未开票'
                break
              case '3':
                status = '已开票'
                break
              case '4':
                status = '已退款'
                break
              case '5':
                status = '未收服务费'
                break
            }
            return h('div', status)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 230,
          render: (h, params) => {
            let operateArray = [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.makeInvoice(params.row)
                  }
                }
              }, '开票'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showInvoice(params.row)
                  }
                }
              }, '发票信息'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.refund(params.row)
                  }
                }
              }, '退款'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: true
                },
              }, '已退款')
            ]
            let resultArray = []
            switch (params.row.orderStatus) {
              // 红冲
              case '0':
                // resultArray = operateArray.slice(0).splice(1, 1)
                break
              // 未开票未支付
              case '1':
                break
              // 未开票已支付
              case '2':
                resultArray = operateArray.slice(0).splice(0, 3)
                break
              // 已开票已支付
              case '3':
                resultArray = operateArray.slice(0).splice(0, 3)
                break
              // 已红冲或已退款
              case '4':
                resultArray = operateArray.slice(0).splice(0, 2).concat(operateArray.slice(0).splice(3, 1))
                break
              // 已开票未支付
              case '5':
                resultArray = operateArray.slice(0).splice(0, 2)
                break
            }
            return h('div', resultArray);
          }
        }
      ],
      invoiceEnroll: {},
      redInvoiceVisible: false,
      redInvoiceHm: '',
      redInvoiceMaker: '',
      redInvoiceTime: '',
      redInvoicePayee: '唐惠英',
      redInvoiceCheck: '何梓豪',
      orderData: {},
      isHandle: true,
      bankAccountArr: [],
      selectAccount: '',
      selectAccountData: '',
      pageSpin: false,
      extraQuery: {
        rolePermission: ''
      },
      viewServiceInfo: {},
      serviceInfoVisible: false,
      serviceConfirm: '',
      isPushMoney: 0,
      serviceDepartment: '',
      departments: [],
      serviceType: 'supplier',
      supplierVisible: false,
      selectProject: {},
      roleNames: '',
      ifGetService: 1,
      additionInfo: {
        paymentType: '',
        getFeeTime: '',
        serviceAmount: '',
        invoiceNum: '',
        pactNo: '',
        pactTime: '',
        backTime: '',
        invoiceTime: '',
      },
      invoiceEditVisible: false,
      invoiceEdit: {
        invoiceHm: '',
        invoiceDate: '',
        invoiceAmount: ''
      },
      invoiceRepairInfo: {},
      isRapidSelect: false,
      invoiceList: [],
      invoiceListVisible: false,
      selectInvoice: '',
      invoiceColumns: [
        {
          title: '发票号码',
          key: 'invoiceHm',
        },
        {
          title: '发票金额',
          key: 'invoiceAmount',
          width: 120,
        },
        {
          title: '开票时间',
          width: 100,
          key: 'invoiceTime',
          render: (h, params) => {
            let time = '无开票时间'
            if (params.row.invoiceTime) {
              time = formatDate(params.row.invoiceTime).split(' ')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '类型',
          key: 'inputMode',
          width: 85
        },
        {
          title: '种类',
          width: 65,
          render: (h, params) => {
            let invoiceType = {
              '1': '蓝票',
              '2': '红票'
            }
            return h('div', invoiceType[params.row.invoiceType])
          }
        },
        {
          title: '税率',
          key: 'taxRate',
          width: 65
        },
        {
          title: '开票人',
          key: 'kpr',
          width: 75
        },
        {
          title: '操作',
          width: 150,
          render: (h, params) => {
            let display = 'none'
            if (this.financialEditPermission) {
              display = 'inline-block'
            }
            return h('div', [
              // h('Button', {
              //   props: {
              //     type: 'success',
              //     size: 'small'
              //   },
              //   style: {
              //     marginRight: '5px',
              //   },
              //   on: {
              //     click: () => {
              //       if (params.row.inputMode === '电子发票') {
              //         window.open(params.row.pdfUrl)
              //       }
              //       this.$Message.info('非电子发票')
              //     }
              //   }
              // }, '下载'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.selectInvoice = params.row
                    if (params.row.inputMode === '录入发票' || params.row.inputMode === '电子发票') {
                      this.invoiceInputMode = params.row.inputMode
                      this.redInvoiceVisible = true
                    }
                  }
                }
              }, '红冲'),
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     marginRight: '5px',
              //   },
              //   on: {
              //     click: () => {
              //       this.sendInvoiceMessage(params.row, this.orderData, 'mail')
              //     }
              //   }
              // }, '邮箱通知'),
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     marginRight: '5px',
              //   },
              //   on: {
              //     click: () => {
              //       this.sendInvoiceMessage(params.row, this.orderData, 'phone')
              //     }
              //   }
              // }, '短信通知'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  display: display
                },
                on: {
                  click: async () => {

                    if (params.row.inputMode === '电子发票') {
                      this.$Message.error('电子发票无法修改')
                      return
                    }

                    this.invoiceEdit.invoiceHm = ''
                    this.invoiceEdit.invoiceDate = ''
                    this.invoiceEdit.invoiceAmount = ''
                    this.selectInvoice = ''

                    this.selectInvoice = params.row
                    this.invoiceEdit.invoiceHm = params.row.invoiceHm
                    this.invoiceEdit.invoiceAmount = params.row.invoiceAmount
                    this.invoiceEdit.invoiceDate = formatDate()
                    if (params.row.invoiceTime) {
                      this.invoiceEdit.invoiceDate = formatDate(params.row.invoiceTime)
                    }

                    this.invoiceEditVisible = true
                  }
                }
              }, '票改'),
            ])
          }
        }
      ],
      projectPhone: '',
      contactVisible: false
    }
  },
  async created() {
    this.initEnroll()
  },
  mounted() {
    this.getAllDepart()
  },
  computed: {
    financialEditPermission() {
      return this.$store.getters['session/hasRoles']('财务流编辑')
    },
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'serviceCharge') {
        this.changeEnroll(this.currentPage, this.searchValue)
      }
    },
    // 清空报名录入数据
    enrollFormVisible(val) {
      if (!val) {
        this.supplierInputForm.groupArr = []
        this.importMode = false
        this.supplierInputForm = {
          groupArr: [],
          companyName: '',
          companyNo: '',
          companyAddress: '',
          companyTel: '',
          companyMail: '',
          legalPerson: '',
          LegalPersonTel: '',
          projectContact: '',
          projectPhone: '',
          projectMail: '',
          projectFax: '',
          transactor: '',
          transactorPhone: '',
          openBank: '',
          openAccount: '',
          gainMode: '',
          gainEmail: '',
          groupId: '',
          serviceAmount: ''
        }
      }
    }
  },
  methods: {
    accountChange(val) {
      for (let i = 0; i < this.bankAccountArr.length; i++) {
        if (this.bankAccountArr[i].id === val) {
          this.selectAccountData = this.bankAccountArr[i]
          break
        }
      }
    },
    async getBankAccount(area = '', bankName = '') {
      // 获取项目所属分子公司
      let req = await ajax.get(`/api/services/app/ClProjectDb/GetById?id=${this.enrollRepData.projectId}`)
      let filter = ''
      let areaFilter = area ? ` and (district=="${area}" or xhfCompanyName=="广东采联采购科技有限公司" or xhfCompanyName=="采联国际招标采购集团有限公司")` : ''
      let bankNameFilter = bankName ? ` and xhfBankName.contains("${bankName}")` : ''
      let companyName = req.data.result.companyName
      if (this.$store.getters["session/hasRoles"]("财务流编辑")) {
        filter = areaFilter + bankNameFilter
      } else {
        if (companyName.indexOf('采联采购招标有限公司') != -1){
          filter = areaFilter + bankNameFilter + ` and cName == "${req.data.result.companyName}"`
        } else {
          filter = areaFilter + bankNameFilter + ` and (cName == "${req.data.result.companyName}" or xhfCompanyName=="广东采联采购科技有限公司" or xhfCompanyName=="采联国际招标采购集团有限公司")`
        }
      }
      filter = filter.slice(5)
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: filter
        }
      })
      if (rep.data.success) {
        this.bankAccountArr = rep.data.result.items
      }
    },
    serviceBankChange() {
      let paymentType = ''
      if (this.paymentType === '广发银行' || this.paymentType === '建设银行') {
        paymentType = this.paymentType
      }
      this.getBankAccount(this.serviceDepartment, paymentType)
    },
    async initEnroll() {
      this.pageSpin = true
      let rep = await ajax.get(requestUrls.AbpServiceCharge.getPaged, {
        params: {
          maxResultCount: 10,
          skipCount: 0,
          sorting: 's.creationTime desc',
          filter: ''
        }
      })
      this.pageSpin = false
      if (rep.data.success) {
        this.enrollData = this.filterData(rep.data.result.items)
        this.enrollTotalCount = rep.data.result.totalCount
      }
    },
    async changeEnroll(page, { searchNum, searchStatus, searchArea, searchCompanyName, searchNumAbbr, searchPayType, searchPayTime }) {
      let dbSearNum = !searchNum ? '' : ` and s.projectFull.Contains("${searchNum}")`
      let dbSearNumAbbr = !searchNumAbbr ? '' : ` and s.projectShort.Contains("${searchNumAbbr}")`
      let dbSearArea = !searchArea ? '' : ` and s.district.Contains("${searchArea}")`
      let dbSearStatus = !searchStatus ? '' : ` and s.status == "${searchStatus}"`
      let dbSearCompanyName = !searchCompanyName ? '' : ` and s.companyName.Contains("${searchCompanyName}")`
      let dbSearPayType = !searchPayType ? '' : ` and o.payChannel.Contains("${searchPayType}")`
      let dbSearPayTime = searchPayTime.length > 0 && searchPayTime[0] !== '' ? ` and o.payTime >= "${searchPayTime[0]}" and o.payTime <= "${searchPayTime[1]}"` : ''
      let filterData = dbSearNum + dbSearArea + dbSearStatus + dbSearCompanyName + dbSearNumAbbr + dbSearPayType + dbSearPayTime + this.extraQuery.rolePermission
      this.pageSpin = true
      let rep = await ajax.get(requestUrls.AbpServiceCharge.getPaged, {
        params: {
          maxResultCount: 10,
          skipCount: (page - 1) * 10,
          filter: filterData.slice(5),
          sorting: 's.creationTime desc'
        }
      })
      this.pageSpin = false
      if (rep.data.success) {
        this.enrollData = this.filterData(rep.data.result.items)
        this.enrollTotalCount = rep.data.result.totalCount
        if (page === 1) {
          this.$refs.page.currentPage = 1
        }
      }
    },
    pageChange(page) {
      this.currentPage = page
      this.changeEnroll(page, this.searchValue)
    },
    searchEnroll() {
      this.currentPage = 1
      this.changeEnroll(1, this.searchValue)
    },
    filterData(data = []) {
      // 拷贝data
      let dataCy = JSON.parse(JSON.stringify(data))
      dataCy.forEach(item => {
        // item.creationTime = item.creationTime.replace('T', ' ')
        switch (item.status) {
          case '0':
            item.statusText = '待审核'
            break
          case '1':
            item.statusText = '审核通过'
            break
          case '2':
            item.statusText = '审核不通过'
            break
          default:
            item.statusText = '状态出错，请联系相关人员'
        }
      })
      return dataCy
    },
    payEnroll(enroll) {
      this.articleData = {
        amount: enroll.amount
      }
      this.enrollRepData = enroll
      this.enrollPriceShow = true
      this.serviceBankChange()
    },
    // 加载过程
    spinShow(text) {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', text)
          ])
        }
      })
    },
    // 无发票直接退款
    directRefund() {
      // 修改原订单状态
      this.$Modal.confirm({
        title: '退款',
        content: '是否确认退款',
        onOk: async () => {
          try {
            this.$Spin.show()
            // 修改原订单状态
            let orderRep = ajax.put(requestUrls.order.updateOrder, {
              id: this.orderData.id,
              orderStatus: '4'
            })
            // 生成退款订单
            let rep = await ajax.post(requestUrls.order.CreateOrders, {
              serviceChargeId: this.enrollRepData.id,
              orderAmountTotal: -this.orderData.orderAmountTotal,
              orderStatus: '0', // 0状态红冲订单
              orderType: this.orderData.orderType,
              redOrderNo: this.orderData.orderNo,
              "payChannel": this.orderData.payChannel,
              "payTime": formatDate(this.refundTime),
              "ghfInvoiceTaxNo": this.orderData.ghfInvoiceTaxNo,
              "ghfCompanyName": this.orderData.ghfCompanyName,
              "ghfCompanyAddress": this.orderData.ghfCompanyAddress,
              "ghfTelphone": this.orderData.ghfTelphone,
              "ghfBankName": this.orderData.ghfBankName,
              "ghfBankAccount": this.orderData.ghfBankAccount,
              "xhfInvoiceTaxNo": this.orderData.xhfInvoiceTaxNo,
              "xhfCompanyName": this.orderData.xhfCompanyName,
              "xhfCompanyAddress": this.orderData.xhfCompanyAddress,
              "xhfTelphone": this.orderData.xhfTelphone,
              "xhfBankName": this.orderData.xhfBankName,
              "xhfBankAccount": this.orderData.xhfBankAccount,
              "projectFull": this.orderData.projectFull,
              "district": this.orderData.district,
              "projectId": this.orderData.projectId,
              "enrollId": '',
              "ordersExp": {
                "bankName": '',
                "bankAccount": '',
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('退款成功')
              this.refundInfoVisible = false
              // 刷新订单
              this.refreshOrders()
              // 修改报名状态
              this.enrollRepData.status = '0'
              let enrollRep = await ajax.post(requestUrls.AbpServiceCharge.createOrUpdate, {
                abpServiceCharge: this.enrollRepData
              })
              // 刷新报名状态
              this.changeEnroll(this.currentPage, this.searchValue)
            } else {
              this.$Message.error('退款失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('退款失败')
          }
        }
      })
    },
    importArticle(article) {
      this.selectProjectData = article
      this.articleData = {
        id: '',
        objectId: article.id,
        amount: '',
        title: article.projectName,
        projectNo: article.projectFull,
        projectShort: article.projectShort,
        district: article.district,
      }
      if (this.serviceType === 'purchaser' || this.serviceType === 'purchaserNoConfirm') {
        this.articleChooseVisible = false
        this.enrollFormVisible = true
      } else {
        this.articleChooseVisible = false
        this.selectProject = article
        this.supplierVisible = true
      }
    },
    importSupplier(row) {
      this.articleChooseVisible = false
      this.supplierInputForm.serviceAmount = ''
      this.supplierInputForm.companyName = ''
      this.supplierInputForm.companyNo = ''
      this.supplierInputForm.groupId = ''
      if (row.receivable) {
        this.supplierInputForm.serviceAmount = row.receivable.toString()
      }
      this.supplierInputForm.companyAddress = row.abpEnroll.companyAddress
      this.supplierInputForm.companyTel = row.abpEnroll.companyTel
      this.supplierInputForm.projectContact = row.abpEnroll.projectContact
      this.supplierInputForm.projectPhone = row.abpEnroll.projectPhone
      this.supplierInputForm.openBank = row.abpEnroll.openBank
      this.supplierInputForm.openAccount = row.abpEnroll.openAccount
      this.supplierInputForm.companyName = row.abpEnroll.companyName
      this.supplierInputForm.companyNo = row.abpEnroll.companyNo
      this.supplierInputForm.groupId = row.groupId
      this.supplierVisible = false
      this.enrollFormVisible = true
    },
    importSupplierDirect(row) {
      this.articleData = {
        id: '',
        objectId: row.projectId,
        amount: '',
        title: '暂不能显示项目名称',
        projectNo: row.abpEnroll.projectFull,
        projectShort: row.abpEnroll.projectShort,
        district: row.abpEnroll.district,
      }
      this.articleChooseVisible = false
      this.supplierInputForm.serviceAmount = ''
      this.supplierInputForm.companyName = ''
      this.supplierInputForm.companyNo = ''
      this.supplierInputForm.groupId = ''
      if (row.receivable) {
        this.supplierInputForm.serviceAmount = row.receivable.toString()
      }
      this.supplierInputForm.companyName = row.abpEnroll.companyName
      this.supplierInputForm.companyNo = row.abpEnroll.projectFull
      this.supplierInputForm.groupId = row.groupId
      this.supplierVisible = false
      this.enrollFormVisible = true
    },
    inputEnroll() {
      this.$refs.supplierInputForm.validate(async valid => {
        if (valid) {
          // 查询重复录入
          let rep = await ajax.get(requestUrls.AbpServiceCharge.getPaged, {
            params: {
              filter: `s.companyName=="${this.supplierInputForm.companyName}" and s.projectId == "${this.articleData.objectId}"`,
              maxResultCount: 5,
              skipCount: 0
            }
          })
          if (rep.data.result.items.length > 0) {
            this.$Modal.confirm({
              title: '重复录入',
              content: '此项目已录入此供应商（或采购人）服务费，是否再次录入？',
              onOk: () => {
                this.enterService()
              }
            })
            return
          }
          this.enterService()
        }
      })
    },
    async enterService() {
      this.spinShow('正在录入数据，请稍后..')
      try {
        // 设置项目应收款
        if (this.serviceType === 'purchaserNoConfirm') {
          this.selectProjectData.receivables = this.supplierInputForm.serviceAmount
          let rep = ajax.post(requestUrls.ClProjectDb.CreateOrUpdate, {
            clProjectDb: this.selectProjectData
          })
        }

        let isBuyer = true
        if (this.supplierInputForm.groupId) {
          isBuyer = false
        }
        // 添加服务费
        const enrollData = {
          "projectId": this.articleData.objectId,
          "projectContact": this.supplierInputForm.projectContact,
          "projectPhone": this.supplierInputForm.projectPhone,
          "openAccount": this.supplierInputForm.openAccount,
          "openBank": this.supplierInputForm.openBank,
          "status": "0",
          "companyAddress": this.supplierInputForm.companyAddress,
          "companyName": this.supplierInputForm.companyName,
          "companyNo": this.supplierInputForm.companyNo,
          "companyTel": this.supplierInputForm.companyTel,
          "isBuyer": isBuyer,
          "amount": this.supplierInputForm.serviceAmount,
          "projectShort": this.articleData.projectShort,
          "projectFull": this.articleData.projectNo,
          "district": this.articleData.district,
          "groupId": this.supplierInputForm.groupId,
          "intermediary": this.supplierInputForm.interService,
        }
        let enrollRep = await ajax.post(requestUrls.AbpServiceCharge.createOrUpdate, { abpServiceCharge: enrollData })
        // 获得enrollId
        if (enrollRep.data.success) {
          this.enrollFormVisible = false
          this.changeEnroll(this.currentPage, this.searchValue)
        }
        this.$Spin.hide()
      } catch (err) {
        this.$Spin.hide()
        console.errro(err)
      }
    },
    // 修改发票信息
    editInvoiceData() {
      this.$Modal.confirm({
        title: '修改发票信息',
        content: '确定修改此发票信息',
        onOk: async () => {
          let invoiceTime = ''
          if (this.invoiceEdit.invoiceDate) {
            invoiceTime = formatDate(this.invoiceEdit.invoiceDate)
          }
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.orderInvoice.ModifyInvoiceNumber, {
              id: this.selectInvoice.id,
              invoiceHm: this.invoiceEdit.invoiceHm,
              invoiceTime: invoiceTime,
              invoiceAmount: this.invoiceEdit.invoiceAmount
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.invoiceEditVisible = false
              this.$Message.success('操作成功')
              this.getInvoiceList(this.orderData)
              
            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            this.$Spin.hide()
            console.error(err)
            this.$Message.error('操作失败')
          }
        }
      })
    },
    // 获取所有部门
    async getAllDepart() {
      let rep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole)
      this.departments = rep.data.result.items
    },
    async setPayment() {
      if (this.serviceDepartment === '') {
        this.$Message.error('请选择服务费领取部门')
        return
      }
      // if (this.serviceConfirm === '') {
      //   this.$Message.error('请输入服务费确认人')
      //   return
      // }
      if (this.paymentType === '') {
        this.$Message.error('请选择支付方式')
        return
      }
      if (this.paymentAccount === '') {
        this.$Message.error('请选择收款账号')
        return
      }
      this.$Modal.confirm({
        title: '收款信息',
        content: '确认收款信息填写正确',
        onOk: async () => {
          // 生成订单。默认已付费
          this.$Spin.show()
          try {
            // 补充服务费信息
            let enrollData = this.enrollRepData
            enrollData.serviceDepartment = this.serviceDepartment
            enrollData.pactNo = this.pactNo
            enrollData.pactTime = ''
            if (this.pactTime) {
              enrollData.pactTime = formatDate(this.pactTime)
            }
            if (this.ifGetService === 0) {
              enrollData.amount = ''
            }
            let serviceRep = ajax.post(requestUrls.AbpServiceCharge.createOrUpdate, { abpServiceCharge: enrollData })

            let orderStatus = '2'
            if (this.ifGetService === 0) {
              orderStatus = '5'
            }

            // 生成订单
            let district = this.selectAccountData.district
            if (district === '军工事业部') {
              district = '广州'
            }
            if (this.selectAccountData.xhfCompanyName === '广东采联采购科技有限公司湛江分公司') {
              district = '广州'
            }
            let rep = await ajax.post(requestUrls.order.CreateOrders, {
              serviceChargeId: this.enrollRepData.id,
              orderAmountTotal: enrollData.amount,
              orderStatus: orderStatus, // 2状态订单已付费
              orderType: '服务费',
              "ghfInvoiceTaxNo": this.enrollRepData.companyNo,
              "ghfCompanyName": this.enrollRepData.companyName,
              "ghfCompanyAddress": this.enrollRepData.companyAddress,
              "ghfTelphone": this.enrollRepData.companyTel,
              "ghfBankName": this.enrollRepData.openBank,
              "ghfBankAccount": this.enrollRepData.openAccount,
              "xhfInvoiceTaxNo": this.selectAccountData.xhfInvoiceTaxNo,
              "xhfCompanyName": this.selectAccountData.xhfCompanyName,
              "xhfCompanyAddress": this.selectAccountData.xhfCompanyAddress,
              "xhfTelphone": this.selectAccountData.xhfTelphone,
              "xhfBankName": this.selectAccountData.xhfBankName,
              "xhfBankAccount": this.selectAccountData.xhfBankAccount,
              "projectFull": this.enrollRepData.projectFull,
              "district": district,
              "projectId": this.enrollRepData.projectId,
              "enrollId": '',
              "ordersExp": {
                "bankName": "",
                "bankAccount": "",
              }
            })
            if (rep.data.success) {
              // 修改服务费状态
              this.enrollRepData.status = '1'
              let enrollRep = await ajax.post(requestUrls.AbpServiceCharge.createOrUpdate, {
                abpServiceCharge: this.enrollRepData
              })

              let paymentType = this.paymentType
              let payTime = formatDate(this.payTimeValue)
              if (this.ifGetService === 0) {
                paymentType = '',
                payTime = ''
              }

              // 修改支付时间
              let payTimeRep = await ajax.put(requestUrls.order.updateOrdersPay, {
                id: rep.data.result.id,
                payChannel: paymentType,
                payTime: payTime,
                orderAmountTotal: enrollData.amount
              })
              this.$Spin.hide()
              if (enrollRep.data.success) {
                this.changeEnroll(this.currentPage, this.searchValue)
                this.enrollPriceShow = false
                this.$Message.success('收款信息添加成功')
              } else {
                this.$Message.error('收款信息添加失败')
              }
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('收款信息添加失败')
          }
        }
      })
    },
    async invoiceAndRefund(enroll) {
      this.invoiceEnroll = enroll
      this.spinShow('正在查询缴费记录..')
      try {
        let rep = await ajax.get(requestUrls.order.getPaged, {
          params: {
            filter: `serviceChargeId == "${enroll.id}" and orderType == "服务费"`,
            maxResultCount: 100,
            skipCount: 0,
            sorting: 'orderNo'
          }
        })
        if (rep.data.success) {
          this.orderList = rep.data.result.items
          this.ordersVisible = true
        }
        this.$Spin.hide()
      } catch (err) {
        cosnole.log(err)
        this.$Spin.hide()
      }
    },
    // 开电子发票
    async makeInvoice(order) {
      this.isHandle = true
      this.invoiceData = order
      this.makeInvoiceVisible = true
    },
    async getInvoice(order) {
      this.spinShow('正在获取发票信息..')
      try {
        // 一个订单对应一个发票
        let rep = await ajax.get(requestUrls.orderInvoice.getPaged, {
          params: {
            filter: `orderNo == "${order.orderNo}"`,
            maxResultCount: 1,
            skipCount: 0
          }
        })
        if (rep.data.success) {
          let result = rep.data.result.items[0]
          if (result.pdfUrl) {
            window.open(result.pdfUrl)
          } else {
            let invoiceTime = '无'
            if (result.invoiceTime) {
              invoiceTime = result.invoiceTime.split('T')[0]
            }
            let invoiceHm = result.invoiceHm
            if (result.invoiceHm.length > 20) {
              invoiceHm = '无'
            }
            this.$Modal.confirm({
              title: '录入发票',
              cancelText: '',
              render: (h) => {
                return h('div', {
                  style: {
                    padding: '10px 20px'
                  }
                }, [
                    // h('div', `发票代码：${result.invoiceDm}`),
                    h('div', `发票号码：${invoiceHm}`),
                    h('div', `开票日期：${invoiceTime}`),
                    h('div', `金额：${result.invoiceAmount}`),
                  ])
              }
            })
          }
        }
        this.$Spin.hide()
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('发票异常')
      }
    },
    finishInvoice() {
      this.makeInvoiceVisible = false
      this.refreshOrders()
    },
    // 刷新订单列表
    async refreshOrders() {
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          filter: `serviceChargeId == "${this.invoiceEnroll.id}" and orderType == "服务费"`,
          maxResultCount: 100,
          skipCount: 0,
          sorting: 'orderNo'
        }
      })
      if (rep.data.success) {
        this.orderList = rep.data.result.items
      }
    },
    // 退款
    async refund(order) {
      this.orderData = order
      this.refundInfoVisible = true
    },
    makeRedInvoice() {
      if (this.invoiceInputMode === '录入发票') {
        if (this.redInvoiceHm === '' || !this.redInvoiceHm) {
          this.$Message.error('发票号码不能为空')
          return
        }
        if (this.redInvoiceTime === '' || !this.redInvoiceTime) {
          this.$Message.error('发票时间不能为空')
          return
        }
      }
      if (this.redInvoiceMaker === '' || !this.redInvoiceMaker) {
        this.$Message.error('开票人姓名不能为空')
        return
      }
      if (this.redInvoicePayee === '' || !this.redInvoicePayee) {
        this.$Message.error('收款人姓名不能为空')
        return
      }
      if (this.redInvoiceCheck === '' || !this.redInvoiceCheck) {
        this.$Message.error('复核人姓名不能为空')
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: '即将开出红冲发票，此操作无法撤回，请注意',
        onOk: async () => {
          this.spinShow('正在开票，请稍后..')
          try {
            // 开票
            let rep = {}
            if (this.invoiceInputMode === '录入发票') {
              let invoiceTime = formatDate()
              rep = await ajax.post(requestUrls.orderInvoice.ManualRedInvoice, {
                invoiceHm: this.redInvoiceHm,
                invoiceTime: invoiceTime,
                // orderNo: this.orderData.orderNo,
                idplus: this.selectInvoice.id,
                kpr: this.redInvoiceMaker,
                skr: this.redInvoicePayee,
                fhr: this.redInvoiceCheck,
              })
            } else if (this.invoiceInputMode === '电子发票') {
              rep = await ajax.post(requestUrls.orderInvoice.CreateRedInvoice, {
                // orderNo: this.orderData.orderNo,
                idplus: this.selectInvoice.id,
                kpr: this.redInvoiceMaker,
                skr: this.redInvoicePayee,
                fhr: this.redInvoiceCheck,
              })
            }
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('操作成功')
              this.redInvoiceVisible = false
              this.getInvoiceList(this.orderData)
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })

    },
    cancelExaminePay(val) {
      if (!val) {
        // 刷新报名列表（报名录入需要）
        this.changeEnroll(this.currentPage, this.searchValue)
        // 清空付款账号
        this.selectAccount = ''
        this.selectAccountData = ''
        // 重置支付方式
        this.paymentType = ''
        // this.realPayAccountName = ''
        // this.realPayAccount = ''
        this.isPushMoney = 0
        this.serviceDepartment = ''
        this.ifGetService = 1
        this.pactNo = ''
        this.pactTime = ''
        this.serviceConfirm = ''
      } else {
        this.payTimeValue = new Date()
      }
    },
    async confirmService() {
      if (this.serviceConfirm === '') {
        this.$Message.error('请输入确认人')
        return
      }
      let isPushMoney = false
      if (this.isPushMoney === 1) {
        isPushMoney = true
      }
      this.$Spin.show()
      try {
        let rep = await ajax.post(requestUrls.AbpServiceCharge.ServiceChargeConfirm, {
          id: this.enrollRepData.id,
          isPushMoney: isPushMoney,
          serviceConfirm: this.serviceConfirm
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('确认成功')
        } else {
          this.$Message.error('确认失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('确认失败')
      }
    },
    async supplyOtherInfo() {
      try {
        this.$Spin.show()

        let pactTime = ''
        let payTime = ''
        let marginReturnTime = ''
        if (this.additionInfo.pactTime) {
          pactTime = formatDate(this.additionInfo.pactTime)
        }
        if (this.additionInfo.getFeeTime) {
          payTime = formatDate(this.additionInfo.getFeeTime)
        }
        if (this.additionInfo.backTime) {
          marginReturnTime = formatDate(this.additionInfo.backTime)
        }

        let rep = await ajax.post(requestUrls.AbpServiceCharge.ServiceRepair, {
          "id": this.enrollRepData.id,
          "pactTime": pactTime,
          "pactNo": this.additionInfo.pactNo,
          "amount": this.additionInfo.serviceAmount,
          "payTime": payTime,
          "payChannel": this.additionInfo.paymentType,
          "marginReturnTime": marginReturnTime,
          "comment": this.additionInfo.comment
        })

        // 修改订单支付时间和支付方式
        let payTimeRep = await ajax.put(requestUrls.order.updateOrdersPay, {
          id: this.enrollRepData.ordersDto.id,
          payChannel: this.additionInfo.paymentType,
          payTime: payTime,
          orderAmountTotal: this.additionInfo.serviceAmount
        })

        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('操作成功')
          this.extraInfoVisible = false
          this.changeEnroll(1, this.searchValue)

          // 修改订单状态(填写了服务费)
          if (this.additionInfo.serviceAmount) {
            ajax.put(requestUrls.order.updateOrder, {
              id: this.enrollRepData.ordersDto.id,
              orderStatus: '3'
            })
          }


        } else {
          this.$Message.error('操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    // async supplyInvoice() {
    //   this.$Spin.show()
    //   let invoiceTime = ''
    //   if (this.additionInfo.invoiceTime) {
    //     invoiceTime = formatDate(this.additionInfo.invoiceTime)
    //   }
    //   try {
    //     let rep = await ajax.post(requestUrls.orderInvoice.InvoiceRepair, {
    //       "id": this.invoiceRepairInfo.id,
    //       "invoiceHm": this.additionInfo.invoiceNum,
    //       "invoiceTime": invoiceTime
    //     })
    //     this.$Spin.hide()
    //     if (rep.data.success) {
    //       this.$Message.success('操作成功')
    //       this.extraInfoVisible = false
    //       this.changeEnroll(1, this.searchValue)
    //     } else {
    //       this.$Message.error('操作失败')
    //     }
    //   } catch (err) {
    //     console.error(err)
    //     this.$Spin.hide()
    //     this.$Message.error('操作失败')
    //   }
    // },
    showServiceReport() {
      window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B670d%5D%5B52a1%5D%5B8d39%5D%5B6536%5D%5B5165%5D%2FServiceCharge.cpt`)
    },
    async showInvoice(order) {
      this.orderData = order
      await this.getInvoiceList(order)
      this.invoiceListVisible = true
    },
    async getInvoiceList(order) {
      this.spinShow('正在获取发票信息..')
      let rep = await ajax.get(requestUrls.orderInvoice.getPaged, {
        params: {
          filter: `orderNo == "${order.orderNo}"`,
          maxResultCount: 100,
          skipCount: 0,
        }
      })
      this.$Spin.hide()
      this.invoiceList = []
      if (rep.data.success) {
        this.invoiceList = rep.data.result.items
      }
    },
    contactUpdate() {
      // 手机号验证
      if(!(/^1[3456789]\d{9}$/.test(this.projectPhone))){ 
        this.$Message.error("手机号码有误，请重填")
        return
      }
      // 更新数据
      this.enrollRepData.projectPhone = this.projectPhone
      ajax.post(requestUrls.AbpServiceCharge.createOrUpdate, {
        abpServiceCharge: this.enrollRepData
      }).then(() => {
        this.sendMessage(this.projectPhone)
      })
    },
    // 短信通知
    sendMessage(phoneNumber) {
      // 获取项目信息
      ajax.get(`/api/services/app/ClProjectDb/GetById?id=${this.enrollRepData.projectId}`).then(res => {
        let typeParams = {
          phone: phoneNumber,
          content: `尊敬的${this.enrollRepData.companyName}供应商：${res.data.result.projectName}服务费已到账，请贵司凭领取人的身份证复印件和缴费凭证复印件并加盖单位公章到我司领取中标通知书原件及发票。`
        }
        sendMessage('phoneContent', typeParams)
        this.$Message.success('发送成功')
        this.contactVisible = false
      })
    }
  },
  filters: {
    emptyFilter(val) {
      if (!val) {
        return '无'
      }
      return val
    },
    interServiceFilter(val) {
      if (!val) {
        return '否'
      }
      return '是'
    }
  },
  components: {
    Invoice,
    ProjectChoose,
    // SupplierSelect,
    // SupplierSelectDirect
  }
}
</script>

<style lang="less">
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .input-enroll {
    width: 100px;
    display: inline-block;
  }
}
#input-form {
  margin-bottom: 6px;
  .item-half {
    width: 50%;
  }
  td {
    border: 1px solid #cecece;
  }
  table {
    border: 1px solid #cecece;
  }
  .ivu-input {
    border: 0;
  }
  .ivu-form-item {
    margin-bottom: 0;
  }
  .ivu-form-item-error-tip {
    left: auto;
    top: 5px;
    right: -55px;
  }
  .valid-email {
    .ivu-form-item-error-tip {
      right: -90px;
    }
  }
  .project-group {
    .ivu-form-item-label {
      padding-bottom: 30px;
    }
    .ivu-form-item-error-tip {
      left: -75px;
      top: 30px;
    }
  }
  .ivu-checkbox-group {
    label {
      display: inline-block;
      width: 100%;
    }
  }
}
.enroll-files {
  li {
    list-style: none;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
  }
  .ivu-card-body {
    padding-top: 0;
  }
}
.ivu-modal {
  top: 50px;
}
.workbreak {
  display: inline-block;
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.redinvoice-item {
  padding: 5px;
}
.service-form {
  .ivu-form-item {
    margin-bottom: 10px;
    label {
      font-weight: 600;
    }
  }
}
.info-modal {
  .ivu-card-body {
    padding-bottom: 0;
  }
  .ivu-card {
    margin-top: 5px;
  }
}
</style>
